import { render, staticRenderFns } from "./Alphabetic.vue?vue&type=template&id=0c5cee09&scoped=true&"
import script from "./Alphabetic.vue?vue&type=script&lang=js&"
export * from "./Alphabetic.vue?vue&type=script&lang=js&"
import style0 from "./Alphabetic.vue?vue&type=style&index=0&id=0c5cee09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cee09",
  null
  
)

export default component.exports